<template>
    <div style="padding:30px;">
        <el-alert :closable="false" title="menu - 1 -2 " type="warning" />
    </div>
</template>

<script>
    export default {
        name: "Menu12"
    }
</script>

<style scoped>

</style>
